<template>
<!-- 
xs(Extra Small)・・・主にスマホ対応
sm(Small)・・・主にタブレット
md(Medium) ・・・主にノートパソコンや横表示のタブレット
lg(Large)・・・主にデスクトップ
xl(Extra large)・・・4Kや大きなモニター 


v-if="$vuetify.breakpoint.xs"
-->
    <v-dialog v-if="isView" v-model="isView" persistent width="800">
        <v-card class="mt-3 pa-1">
            <Title title="環境記録">
                <v-spacer />
                <TitleButton
                    icon="mdi-close-circle"
                    name="閉じる"
                    @click="isView = false" />
            </Title>
            <v-card-text class="pa-0">
                <v-container>
                    <v-row dense>
                        <v-col>
                            <table>
                                <tr>
                                    <td>
                                        <v-btn icon @click="onClickPreviusMeasureItem" color="primary">
                                            <v-icon>mdi-chevron-left-circle</v-icon>
                                        </v-btn>
                                    </td>
                                    <td style="width:100%">
                                        <v-select 
                                            v-model="currentMeasureItem"
                                            dense
                                            label="測定項目"
                                            outlined
                                            hide-details
                                            :items="measureItems"
                                            item-text="body.name"
                                            return-object
                                            @change="onSelectedMeasureItem"/>
                                    </td>
                                    <td>
                                        <v-btn icon @click="onClickNextMeasureItem" color="primary">
                                            <v-icon>mdi-chevron-right-circle</v-icon>
                                        </v-btn>
                                    </td>
                                </tr>
                                <tr v-if="currentMeasureItem != null && !$vuetify.breakpoint.xs">
                                    <td></td>
                                    <td>
                                        <table>
                                            <tr>
                                                <td><v-chip label color="primary" small>最小値:{{currentMeasureItem.body.min}}</v-chip></td>
                                                <td><v-chip label color="primary" small>最大値:{{currentMeasureItem.body.max}}</v-chip></td>
                                                <td><v-chip label color="primary" small>測定単位:{{currentMeasureItem.body.step}}</v-chip></td>
                                                <td><v-chip label color="primary" small>単位:{{currentMeasureItem.body.unit}}</v-chip></td>
                                            </tr>
                                        </table>
                                    </td>
                                </tr>
                            </table>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4">
                            <DatePicker 
                                label="測定日"
                                v-model="editItems.measureDate"
                                dense
                                :clearable="false"
                                :max="maxDate"
                                @change="onChangedDate"
                                icon="" />
                        </v-col>
                        <v-col cols="6" xs="6" sm="4" md="4" lg="4" xl="4">
                            <NumInput 
                                v-model="editItems.measureTime.hour" 
                                suffix="時"
                                label="測定時刻(時)" 
                                outlined
                                hide-details 
                                type="text" 
                                dense
                                :canEdit="currentMeasureItem != null && currentMeasureItem.body.auto == false && canRecordWork"
                                align="align-left"
                                :min="0"
                                :max="23"
                                class="mr-2" />
                        </v-col>
                        <v-col cols="6" xs="6" sm="4" md="4" lg="4" xl="4">
                            <NumInput 
                                v-model="editItems.measureTime.minute" 
                                suffix="分"
                                label="測定時刻(分)" 
                                outlined
                                hide-details 
                                type="text" 
                                :min="0"
                                :max="59"
                                dense
                                :canEdit="currentMeasureItem != null && currentMeasureItem.body.auto == false && canRecordWork"
                                align="align-left" />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <NumInput 
                                v-model="editItems.measureValue" 
                                :suffix="currentMeasureItem != null ? currentMeasureItem.body.unit : ''"
                                label="測定値" 
                                outlined
                                hide-details 
                                type="text" 
                                dense
                                align="align-left"
                                @clickAppendOuter="onClickSetValue"
                                :canEdit="currentMeasureItem != null && currentMeasureItem.body.auto == false && canRecordWork"
                                :append-outer-icon="currentMeasureItem != null && currentMeasureItem.body.auto == false && canRecordWork ? 'mdi-arrow-down-bold-circle-outline' : ''" />
                            <span
                                v-if="currentMeasureItem != null && currentMeasureItem.body.auto"
                                style="font-size:x-small; color:red">
                                ※自動取得の測定項目は、値の変更は行えません。
                            </span>
                        </v-col>
                    </v-row>
                    <!-- <v-row v-if="currentHistories != null" dense>
                        <v-col v-for="value in currentHistories.values" :key="value.time" cols="2">
                            <ValueViewer :measureItem="currentMeasureItem" :value="value" @click="onClickMeasuredValue" />
                        </v-col>
                    </v-row> -->
                    <!-- <template v-if="currentHistories != null">
                        <template v-for="hour in 24">
                            <v-row dense :key="hour" >
                                <template v-for="value in currentHistories.values">
                                    <v-col v-if="value.time >= ('0'+(hour-1)).slice(-2) + ':00' && value.time <= ('0'+(hour-1)).slice(-2) + ':59' " :key="value.time">
                                        <ValueViewer :measureItem="currentMeasureItem" :value="value" @click="onClickMeasuredValue" />
                                    </v-col>
                                </template>
                            </v-row>
                        </template>
                    </template> -->
                    <v-row v-if="currentHistories != null">
                        <v-col>
                            <table style="width:100%">
                                <template v-for="hour in 24">
                                    <tr dense :key="hour" >
                                        <template v-for="value in currentHistories.values">
                                            <td v-if="value.time >= ('0'+(hour-1)).slice(-2) + ':00' && value.time <= ('0'+(hour-1)).slice(-2) + ':59' " :key="value.time">
                                                <ValueViewer :measureItem="currentMeasureItem" :value="value" @click="onClickMeasuredValue" />
                                            </td>
                                        </template>
                                    </tr>
                                </template>
                            </table>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
    Date.prototype.toFormatString = function (format) {
        const year = this.getFullYear()
        const month = this.getMonth() + 1
        const month2 = ("0" + month).slice(-2)
        const day2 = ("0" + this.getDate()).slice(-2)
        const hour2 = ("0" + this.getHours()).slice(-2)
        const minute2 = ("0" + this.getMinutes()).slice(-2)
        const second2 = ("0" + this.getSeconds()).slice(-2)

        const formattedValue = format.replace("yyyy", year).replace("MM", month2).replace("dd", day2).replace("HH", hour2).replace("mm", minute2).replace("ss", second2)

        return formattedValue
    }
    Date.prototype.addDay = function (v) {
        this.setDate(this.getDate()+v)
        return this
    }

    import db from '@/firebase/firestore.js'
    import Title from '@/components/seedling/items/TitleBar'
    import TitleButton from '@/components/tools/TitleBarButton';
    import DatePicker from '@/components/tools/DatePicker';
    import NumInput from '@/components/tools/SoftwareNumKeyboard'
    import ValueViewer from '@/components/place/MeasureValueViewer'
    export default {
        components: {
            Title,
            TitleButton,
            DatePicker,
            NumInput,
            ValueViewer
        },
        props: {
            /**
             * 場所
             */
            place: null,
            /**
             * 全測定項目
             */
            measureItems: null
        },
        computed: {
            userUID: function () {
                return this.$store.getters["userUID"]
            },
            /**
             * 共有モード
             */
            shareMode: function () {
                return this.$store.getters["shareMode"]
            },
            /**
             * 共有モードの全種類
             */
            shareModeTypes: function () {
                return this.$store.getters["shareModeTypes"]
            },
            /** グループユーザーの圃場管理を参照中は True */
            isShareMode: function () {
                if (this.shareMode == this.shareModeTypes.groupUserWork) {
                    return true
                }
                return false
            },
            /**
             * 共有中に参照しているユーザーが所属しているグループでの自分のユーザーデータ
             */
            shareUserGroupMyUserData: function () {
                return this.$store.getters["managementItems/shareUserGroupMyUserData"]
            },
            /**
             * 作業記録の権限があるか否か
             */
            canRecordWork: function () {
                // console.log("canRecordWork", this.place.body)
                // if (!this.isShareMode) return true
                // return this.mi_checkGroupUserAuthority(this.place.body, ["browse", "environment", "environment.record"])
                return this.checkAuthority(["browse", "environment", "environment.record"])
            },
            /**
             * 指定された権限を全て持つか否かを返す(共有中ではない時は、必ず True。共有中はチェック結果を返す)
             */
            checkAuthority: function () {
                return function (authorities) {
                    const self = this
                    if (!self.isShareMode) {
                        return true
                    }

                    if (self.place.authorities == null) {
                        return false
                    }

                    const groupAuthorities = self.place.authorities.find((v)=>v.ownerUserUID == self.shareUserGroupMyUserData.ownerUserUID && v.groupNo == self.shareUserGroupMyUserData.groupNo)
                    const userAuthorities = groupAuthorities != null ? groupAuthorities.users[self.loggedInUserUID] : null

                    // console.log("checkAuthority", place, this.shareUserGroupMyUserData, this.loggedInUserUID, groupAuthorities, userAuthorities)

                    if (userAuthorities != null) {
                        for (var authority of authorities) {
                            if (userAuthorities.findIndex((v)=>v == authority) < 0) {
                                console.log("user authority", authority, "deny!!")
                                return false
                            }
                            console.log("user authority", authority, "allow!!")
                        }
                        console.log("user authority", "all allow!!", authorities, userAuthorities)
                        return true
                    }

                    if (self.mi_checkGroupUserAuthority(self.place.body, authorities)){
                        return true
                    }
                    return false
                }
            },
        },
        data: function () {
            return {
                isView: false,
                /** 選択されている測定項目 */
                currentMeasureItem: null,
                /** 選択されている測定項目のインデックス */
                currentMeasureItemIndex: 0,
                /** 画面に表示する選択されている測定日の履歴データ */
                currentHistories: null,
                /** 編集項目 */
                editItems: {
                    measureDate: "",
                    measureTime: {
                        hour: 0,
                        minute: 0
                    },
                    measureValue: 0
                },
                /** 指定可能な最大の作業日 */
                maxDate: (new Date()).toFormatString("yyyy-MM-dd")
            }
        },
        watch: {
            currentMeasureItem: function (value, old) {
                console.log("currentMeasureItem changed", this.currentMeasureItem, this.editItems)
                this.refreshCurrentDailyHistory()
            },
            "editItems.measureDate": function (value, old) {
                console.log("measureDate changed", this.currentMeasureItem, this.editItems)
                this.refreshCurrentDailyHistory()
            }
        },
        methods: {
            /**
             * 前の測定項目ボタン押下時 
             */
            onClickPreviusMeasureItem: function () {
                if (this.currentMeasureItemIndex == 0) {
                    this.currentMeasureItemIndex = this.measureItems.length - 1
                } else {
                    this.currentMeasureItemIndex--
                }
                this.setMeasureItem()
            },
            /**
             * 次の測定項目ボタン押下時 
             */
            onClickNextMeasureItem: function () {
                if (this.currentMeasureItemIndex >= this.measureItems.length - 1) {
                    this.currentMeasureItemIndex = 0
                } else {
                    this.currentMeasureItemIndex++
                }
                this.setMeasureItem()
            },
            /**
             * 測定項目選択時
             */
            onSelectedMeasureItem: function () {
            },
            /**
             * 測定日変更時
             */
            onChangedDate: function () {
            },
            /**
             * 測定値セットボタン押下時
             */
            onClickSetValue: function () {
                console.log(this.currentHistories)
                const self = this

                const selectedDate = new Date(this.editItems.measureDate)
                const yearMonth = selectedDate.toFormatString("yyyy-MM")
                const measureTime = ("0"+this.editItems.measureTime.hour).slice(-2) + ":" + ("0"+this.editItems.measureTime.minute).slice(-2)

                if (this.currentHistories == null) {
                    this.currentHistories = {
                        date: this.editItems.measureDate,
                        measureItemID: this.currentMeasureItem.body.measureItemID,
                        placeID: this.currentMeasureItem.body.placeID,
                        values: [],
                        version: "1.0.0"
                    }
                }
                
                const timeIndex = this.currentHistories.values.findIndex((v)=>v.time == measureTime)
                if (timeIndex < 0) {
                    this.currentHistories.values.push(
                        {
                            time: measureTime,
                            value: this.editItems.measureValue,
                            worker: this.$store.getters["loggedInUserUID"]
                        }
                    )
                    this.currentHistories.values.sort(function(x, y) {
                        if (x.time >= y.time) return 1
                        if (x.time <= y.time) return -1
                        return 0
                    })
                } else {
                    this.currentHistories.values[timeIndex].value = this.editItems.measureValue
                    this.currentHistories.values[timeIndex].worker = this.userUID
                }

                this.currentMeasureItem.histories[yearMonth][selectedDate.getDate()] = this.currentHistories

                db.collection("users").doc(this.userUID)
                .collection("places").doc(this.currentMeasureItem.body.placeID+"")
                .collection("environments").doc(this.currentMeasureItem.body.measureItemID+"")
                .collection("histories").doc(selectedDate.toFormatString("yyyy-MM-dd"))
                .set(this.currentHistories).then(function(){
                    self.$store.commit("notification", {message:"測定値を登録しました。"})
                }).catch (function(error) {
                    self.$store.commit("notification", {message:"測定値の登録に失敗しました。", isError:true})
                    console.log(error)
                })

                this.$emit("onUpdatedMeasureValue", this.currentMeasureItem)
                console.log(this.currentMeasureItem.histories)
            },
            /**
             * 測定値押下時
             */
            onClickMeasuredValue: function (value) {
                console.log("onClickMeasuredValue", value)
                const timeValues = value.time.split(":")
                this.editItems.measureTime.hour = timeValues[0] * 1
                this.editItems.measureTime.minute = timeValues[1] * 1
                this.editItems.measureValue = value.value
            },
            /**
             * 画面に表示する選択されている測定日の履歴データを更新します。
             */
            refreshCurrentDailyHistory: function () {
                console.log("refreshCurrentDailyHistory start", this.editItems, this.currentMeasureItem)

                this.currentHistories = null

                if (this.editItems.measureDate == "") {
                    return
                }

                if (this.currentMeasureItem == null) {
                    return
                }

                const self = this
                const selectedDate = new Date(this.editItems.measureDate)
                const yearMonth = selectedDate.toFormatString("yyyy-MM")

                if (this.currentMeasureItem.histories[yearMonth] == null) {
                    /** 対象月の測定データを取得していない時は、データベースから取得 */
                    console.log("measure data get from DB")
                    this.currentMeasureItem.histories[yearMonth] = {}

                    db.collection("users").doc(this.userUID)
                    .collection("places").doc(this.currentMeasureItem.body.placeID+"")
                    .collection("environments").doc(this.currentMeasureItem.body.measureItemID+"")
                    .collection("histories")
                    .where("date", ">=", yearMonth + "-01")
                    .where("date","<=", yearMonth + "-31")
                    .orderBy("date", "asc")
                    .get().then(function(snapShot){
                        if (snapShot.size > 0) {
                            var setNum = 0
                            snapShot.forEach(function(doc){
                                const dayValue = doc.data()
                                const d = new Date(dayValue.date)
                                self.currentMeasureItem.histories[yearMonth][d.getDate()] = dayValue
                                if (d.getDate() == selectedDate.getDate()) {
                                    self.currentHistories = self.currentMeasureItem.histories[yearMonth][selectedDate.getDate()]
                                }
                                setNum++
                                if (setNum == snapShot.size) {
                                }
                            })
                        }
                    })

                } else {
                    /** 既に対象月の測定データを取得している時は、そのデータを使用 */
                    this.currentHistories = this.currentMeasureItem.histories[yearMonth][selectedDate.getDate()]
                }
            },
            /**
             * このダイアログを表示
             * @param measureItem 初期選択する測定項目
             */
            show: function (measureItem) {
                console.log(measureItem)
                const currentDateTime = new Date()
                if (measureItem == null) {
                    this.currentMeasureItemIndex = 0
                } else {
                    this.currentMeasureItemIndex = this.measureItems.findIndex((v)=>v.body.measureItemID == measureItem.body.measureItemID)
                }
                this.editItems = {
                    measureDate: currentDateTime.toFormatString("yyyy-MM-dd"),
                    measureTime: {
                        hour: currentDateTime.getHours(),
                        minute: currentDateTime.getMinutes()
                    },
                    measureValue: 0
                }
                this.setMeasureItem()
                this.isView = true
            },
            /**
             * 測定項目をセットします
             */
            setMeasureItem: function () {
                this.currentMeasureItem = this.measureItems[this.currentMeasureItemIndex]
            }
        }
    }
</script>
